<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="25" viewBox="0 0 23 25">
        <g fill="#FFF" fill-rule="evenodd">
            <g>
                <path d="M3.713 6.22l6.354 7.492c-.606.974-1.686 1.622-2.918 1.622-1.897 0-3.436-1.538-3.436-3.436V6.22zM7.15.032c1.898 0 3.436 1.538 3.436 3.436v7.037L3.837 2.549C4.239 1.098 5.57.032 7.149.032z" transform="translate(4.224 1)"/>
                <path fill-rule="nonzero" d="M1.222 11.516c.337 0 .61.28.61.626 0 3.04 2.404 5.503 5.37 5.503 1.767 0 3.335-.875 4.314-2.225l.817.963c-1.208 1.533-3.058 2.514-5.13 2.514-3.641 0-6.592-3.024-6.592-6.755 0-.346.273-.626.61-.626zm11.96 0c.338 0 .611.28.611.626 0 .642-.087 1.263-.25 1.851l-1.01-1.19c.026-.217.039-.437.039-.661 0-.346.273-.626.61-.626z" transform="translate(4.224 1)"/>
                <path fill-rule="nonzero" d="M7.695 17.9c.48 0 .879.222.961.514l.016.113v3.575c0 .346-.437.626-.977.626-.48 0-.878-.221-.96-.513l-.016-.113v-3.575c0-.346.437-.626.976-.626z" transform="translate(4.224 1)"/>
                <path fill-rule="nonzero" d="M8.779 21.476c.337 0 .61.438.61.977 0 .48-.215.879-.5.961l-.11.016H5.943c-.337 0-.61-.437-.61-.977 0-.48.216-.878.5-.96l.11-.017H8.78z" transform="translate(4.224 1)"/>
            </g>
            <path d="M11.316 -3.198L12.551 -3.213 12.174 27.759 10.94 27.774z" transform="rotate(-41 11.745 12.28)"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'audio-muted'
}
</script>